import OfferJobForm from "../../../../../components/forms/offerJobForm";
const CreateJobs = () => {
    return (
        <div>
            <OfferJobForm title="Add Job Category,Education,Work Experience,Area,Job Type" btn="Post Job" url="/company-profile" back="/company-profile" />
        </div>
    )
}
export default CreateJobs;